(function () {
  let header;
  let observer;

  function bindHeader() {
    const nextHeader = document.getElementById('rarely-header');
    if (nextHeader === header) return;
    if (observer) observer.disconnect();
    header = nextHeader;
    if (!header) return;

    // Existing cart and landing-page flows write the badge text directly.
    // Observe that presentation state rather than introducing another cart fetch.
    function syncBadge() {
      const badge = header.querySelector('#cart-badge');
      if (!badge) return;
      badge.classList.toggle('cart-badge--has-items', /^[1-9]\d*$/.test(badge.textContent.trim()));
    }

    syncBadge();
    observer = new MutationObserver(syncBadge);
    observer.observe(header, { childList: true, characterData: true, subtree: true });
  }

  bindHeader();
  document.addEventListener('shopify:section:load', bindHeader);
})();
